import SubcategoryPage from '@/components/template/SubcategoryPage';

const EdmundSgabello = () => {
  const products = [
    {
      title: "Edmund Sgabello Klasični",
      imageSrc: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-sgabello-klasicni"
    },
    {
      title: "Edmund Sgabello Moderni",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-sgabello-moderni"
    },
    {
      title: "Edmund Sgabello Premium",
      imageSrc: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-sgabello-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Edmund Sgabello"
      description="Ikonični Edmund Sgabello stolčki združujejo italijanski dizajn in vrhunsko obrtno izdelavo."
      heroImage="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default EdmundSgabello;